<template>
  <div class="skeleton">
    <div class="shine team" v-if="!hideTeam"></div>
    <avatar-title class="goal" avatar-size="20" line-height="20" />
    <avatar-title class="kr" avatar-size="15" line-height="20" />
  </div>
</template>

<script>
import AvatarTitle from '@/components/skeletons/AvatarTitle'
export default {
  name: 'ActivitySkeleton',
  props: ['hideTeam'],
  components: {
    AvatarTitle
  }
}
</script>

<style lang="scss" scoped>
.skeleton {
  padding-left: 42px;
  margin-top: 6px;
  height: 430px;
}
.team {
  height: 21px;
  padding: 5px 0;
  width: 200px;
  margin-bottom: 23px;
  border-radius: 5px;
}
.goal {
  margin-left: -18px;
}
.kr {
  margin-left: 6px;
  margin-top: 8px;
}
</style>
